import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/elevator/workstatus/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/elevator/workstatus/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/elevator/workstatus/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/elevator/workstatus/submit', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/elevator/workstatus/submit', params,options)

export const getListByCommunity = (params, options) =>
request.get('/api/v4ward/elevator/workstatus/listByCommunity', Object.assign({}, options, { params }))


export const getCommunityTree = (params, options) =>
request.get('/api/base/property/getCommunityTree', Object.assign({}, options, { params }))
